import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import { withStyles, Paper, List, ListItem, ListItemText } from "@material-ui/core";
import t from "../../../../languages/pl";
import guid from '../../../../utils/guid';
import ReportListElement from "./ReportListElement";
import SearchKeywords from './SearchKeywords';
import { notArrayOrEmpty } from '../../../../utils/helpers';
import { tabsPanelHeight, toolbarHeight, standardTextFieldHeight } from './../../../../config/constants';

const useStyles = theme => ({
    paper: {
        minWidth: 340,
        margin: theme.spacing(1),
        marginRight: 0,
        paddingTop: theme.spacing(0.5),
        overflow: "hidden",
    },
});

const ListDiv = styled.div`
    overflow: auto;
    height: ${props => props.height - standardTextFieldHeight - 2*8 - 24 - toolbarHeight - tabsPanelHeight}px;
`;

const ReportsList = props => {
    const { classes, selectedReport, reports, keywords, onReportSelect, screenHeight } = props;
    const [visibleReports, setVisibleReports] = useState(reports);

    useEffect(() => {
        setVisibleReports(reports);
    }, [reports]);

    const handleKeywordsFilter = (keywords) => {
        let filteredReports = reports.filter(report => {
            if(keywords.every(item => report.tagi.includes(item)))
                return report;
        });
        if(!notArrayOrEmpty(keywords))
            setVisibleReports(filteredReports);
        else setVisibleReports(reports);
    };

    const printList = data => {
        if(!Array.isArray(data) || data.length === 0)
            return (
                <ListItem>
                    <ListItemText>
                        {t.noDataInfo}
                    </ListItemText>
                </ListItem>
            );

        return data.map(item => {
            return (
                <ReportListElement
                    key={guid()}
                    id={item.typ_id}
                    name={item.nazwa}
                    keywords={item.tagi}
                    selected={selectedReport && selectedReport.typ_id === item.typ_id}
                    onClick={onReportSelect}
                />
            );
        });
    };

    return (
        <Paper
            square
            className={classes.paper}
        >
            <SearchKeywords
                options={keywords}
                onChange={handleKeywordsFilter}
            />
            <ListDiv height={screenHeight}>
                <List>
                    {printList(visibleReports)}
                </List>
            </ListDiv>
        </Paper>
    );
};

ReportsList.propTypes = {
    classes: PropTypes.object,
    selectedReport: PropTypes.object,
    reports: PropTypes.array,
    keywords: PropTypes.array,
    onReportSelect: PropTypes.func,
    screenHeight: PropTypes.number
};

export default withStyles(useStyles)(ReportsList);
